import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import WhatsAppIntakeModal from "./WhatsAppIntakeModal";

// ---------------------------------------------------------------------------
// Floating WhatsApp button — sticks to bottom-right on every page.
//
// Tapping it (or any element that dispatches the `noi:open-wa-intake`
// CustomEvent — the topbar uses this too) opens a small intake modal that
// captures name + chief complaint BEFORE we deep-link the visitor into
// WhatsApp. This way we capture a structured lead even from visitors who
// never actually reply on WhatsApp.
// ---------------------------------------------------------------------------
export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState("fab");

  useEffect(() => {
    const handler = (e) => {
      setSource(e?.detail?.source || "topbar");
      setOpen(true);
    };
    window.addEventListener("noi:open-wa-intake", handler);
    return () => window.removeEventListener("noi:open-wa-intake", handler);
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => { setSource("fab"); setOpen(true); }}
        aria-label="Chat with us on WhatsApp"
        data-testid="whatsapp-fab"
        className="fixed bottom-5 right-5 z-50 group"
      >
        <span className="relative flex h-14 w-14">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-30" />
          <span className="relative inline-flex h-14 w-14 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-lg items-center justify-center transition">
            <MessageCircle className="w-7 h-7" strokeWidth={2} />
          </span>
        </span>
        <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-slate-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition pointer-events-none shadow-lg">
          Chat with us on WhatsApp
        </span>
      </button>

      <WhatsAppIntakeModal open={open} onClose={() => setOpen(false)} source={source}/>
    </>
  );
}

// Export the number too so footer / contact links can re-use without drift.
export const SUPPORT_WHATSAPP_NUMBER = "918317674160";
export const SUPPORT_WHATSAPP_DISPLAY = "+91 83176 74160";
